import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { RisurComponent } from './risur/risur.component';

const routes: Routes = [  
  { path: '', component: HomeComponent },
  // { path: 'home', component: HomeComponent },
  // { path: 'risur', component: RisurComponent },
  // { path: '', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
